export default "__VITE_ASSET__yB_t7XDM__"